/** Merge these keys under presentations.duplicate in each locale. */
export const duplicateCopy = {
  en: {
    action: 'Duplicate',
    title: 'Duplicate presentation',
    description: 'Create a private draft copy of “{{name}}”.',
    name: 'New presentation name',
    copySuffix: 'copy',
    confirm: 'Create copy',
    pending: 'Creating copy…',
    success: 'Presentation duplicated.',
    errors: {
      default: 'Could not duplicate this presentation.',
      PRESENTATION_CONFLICT: 'The presentation changed. Refresh and try again.',
      ACCESS_DENIED: 'You do not have permission to duplicate this presentation.',
    },
  },
  fa: {
    action: 'تکثیر',
    title: 'تکثیر ارائه',
    description: 'یک نسخه پیش‌نویس خصوصی از «{{name}}» بسازید.',
    name: 'نام ارائه جدید',
    copySuffix: 'کپی',
    confirm: 'ساخت نسخه',
    pending: 'در حال ساخت…',
    success: 'ارائه تکثیر شد.',
    errors: {
      default: 'تکثیر ارائه ناموفق بود.',
      PRESENTATION_CONFLICT: 'ارائه تغییر کرده است. صفحه را تازه‌سازی کنید.',
      ACCESS_DENIED: 'مجوز تکثیر این ارائه را ندارید.',
    },
  },
} as const;
